import { AddButton, ButtonHeading, CommonInput, CommonTextarea, CrossButton, CustomPagination, CustomSelect } from 'components'
import Tab from 'components/common/Tab'
import CustomTooltip from 'components/CustomTooltip/CustomTooltip';
import { constant } from 'constants/constant';
import { AddEditBranch, AddEditEwayBillLrModal, AddEwayBillModal, EbillExtentionModal, EwayBillNewDetailsModal, ExtendEwayBillModal, LrDetailModal } from 'modals';
import AddEditConsignor from 'modals/AddEditConsignor/AddEditConsignor';
import React, { useContext, useEffect, useMemo, useRef, useState } from 'react'
import { IoArrowBackOutline, IoLocationSharp } from 'react-icons/io5';
import PermissionModal from 'modals/PermissionModal';
import { UserContext } from 'context';
import LoadingBar from 'react-top-loading-bar';
import StorageService from 'utils/StorageServices/StorageServices';
import { getEwayBillList, updateLrInformation } from '_services/accountsServices/ewayBillServices';
import { useSelector } from 'react-redux';
import { updateEwayBillFilters } from 'features/ewayBillFilterServices/ewayBillFilterSlice';
import { useDispatch } from 'react-redux';
import MastersFilterModal from 'modals/MastersFilterModal';
import { getBranchDropdownListData, getConsignorDropdownListData } from '_services/dropdownServices/dropdownService';
import toast from 'react-hot-toast';
import moment from 'moment';
import EwayBillFilterModal from 'modals/EwayBillFilterModal/EwayBillFilterModal';
import TimeLineEwayModal from 'modals/TimeLineEwayModal/TimeLineEwayModal';
import { useNavigate } from 'react-router-dom';
import { actionPermission, utils } from 'helper';
import { useUtcButtonState } from 'hooks';
import AddLocationModal from "modals/AddLocationModal";
import AddEwayPartyModal from 'modals/AddEwayPartyModal';
import './ewaybill.css'
import { FaYoutube } from 'react-icons/fa6';
import YoutubeModal from 'modals/YoutubeModal';
import Loading from 'pages/Loading';

const customizeDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = String(date.getUTCDate()).padStart(2, "0");
    const year = date.getUTCFullYear();
    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    const monthName = monthNames[date.getUTCMonth()];

    return `${day} ${monthName} ${year}`;
};

const headerArray = [
    { id: 0, value: "active_lr", count: 0, title: "Active LR" },
    { id: 1, value: "no_eway", count: 0, title: "Without Eway" },
    { id: 2, value: "active_eway", count: 0, title: "Active Eway" },
    // { id: 3,value: "closed", count: 0, title: "Closed" },
    { id: 4, value: "expiring_today", count: 0, title: "Expiring Today" },
    { id: 5, value: "expired", count: 0, title: "Expired" },
    { id: 6, value: "auto_extention_failed", count: 0, title: "Auto Extention Failed" }
]

const getTodayDate = (date) => {
    if (date) {
        const today = new Date(date);
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, "0");
        const day = String(today.getDate()).padStart(2, "0");
        return `${day}/${month}/${year}`;
    }
}

const EwayBill = () => {

    const [headerCounts, setHeaderCounts] = useState(headerArray);
    const loadingBarRef = useRef(null);
    const prevTripFilterRef = useRef();

    const { isButtonEnabled, currentTime } = useUtcButtonState();

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { masterData, setLrDetialsFrom, permissionModal, ewayBillInitialData, setPermissionModal, allMenu, youtubeVideos, setYoutubeVideos } = useContext(UserContext)
    const getEwayBillFilters = useSelector((state) => state.ewayBillFilter)?.filters; // lr_pagination

    const [currentItemData, setCurrentItemData] = useState({});
    const [openLoction, setOpenLoction] = useState({
        open: false,
        action: 'add',
    });

    const [activeTab, setActiveTab] = useState(1);

    const [filterCount, setFilterCount] = useState(0);

    const [listData, setListData] = useState({
        consignorList: [],
        branchList: [],
    });

    const [ewayBillList, setEwayBillList] = useState([]);
    const [loading, setLoading] = useState(false);

    const childsUser = useMemo(() =>
        allMenu?.find((i) => i?.label === 'Trip'),
        [allMenu]
    );

    const itemsPerPage = 25;
    const [totalItems, setTotalItems] = useState(0);
    const [filter, setFilter] = useState({
        limit: 25,
        offset: 1,
        search: '',
    });

    const [showFilterModal, setShowFilterModal] = useState(false);

    const [show, setShow] = useState(false);
    const [showExtendEway, setShowExtendEway] = useState(false);
    const [showEwayTimeline, setShowEwayTimeline] = useState(false);

    const [showEwayDetail, setShowEwayDetail] = useState(false);
    const [isClosing, setIsClosing] = useState(false);

    const [showEwayParty, setShowEwayParty] = useState(false);

    const [showEwayBillModel, setShowEwayBillModel] = useState(false)
    const [isAddConsignor, setIsAddConsignor] = useState(false);

    const [showPrefield, setShowingPrefield] = useState(false);

    const [consignorPermission, setConsignorPermission] = useState({});

    const [showEwayBillDetail, setShowEwayBillDetail] = useState(false);

    const [disableBranchConsignor, setDisableBranchConsignor] = useState(false);

    const [modalConfig, setModalConfig] = useState({
        isOpen: false,
        messageType: null,
        templateId: null,
        templateData: {}
    });


    const openEwayDetail = () => {
        setShowEwayDetail(true);
        setIsClosing(false);
    };

    const closeEwayDetail = () => {
        setIsClosing(true); // trigger exit animation
        setTimeout(() => {
            setShowEwayDetail(false);
            setIsClosing(false);
        }, 300); // must match your CSS transition duration
    };

    const tabChangeFunction = (value) => {
        setActiveTab(value)
        let tabFilter = { ...getEwayBillFilters, eway_bill_status: value, offset: 1 };
        dispatch(updateEwayBillFilters(tabFilter))
    }

    const tabProps = {
        tabList: headerCounts,
        callBackTab: (value) => tabChangeFunction(value),
        activeTab: activeTab
    };

    let firstAddEwayBillModal = {
        isOpen: show,
        currentModelClose: true,
        isOpenModelClose: (e) => { setDisableBranchConsignor(false); setShow(false) },
        addButtonAction: (e) => setIsAddConsignor(e),
        modalMainClass: "_dashCommon_Modal _mdModal",
        modalTitle: "Add Eway Bill",
        submitTitle: "Fetch Data",
        footerPart: true,
        fetchNextModal: (e) => setShowEwayDetail(e), // setShowEwayBillModel(e)
        manualNextModal: (e) => setShowEwayParty(e), // setShowEwayBillModel(e)
        showPrefield: showPrefield,
        disableBranchConsignor: disableBranchConsignor
    }

    let secondAddEwayBillModal = {
        isOpen: showEwayParty,
        isCurrentModelClose: (e) => { setShow(false); setShowEwayParty(false) },
        // previousModal: (e) => { setShowEwayParty(false); setShow(e) },
        manualNextModal: (e) => setShowEwayBillModel(e),
        addButtonAction: (e) => setIsAddConsignor(e),
        modalMainClass: "_dashCommon_Modal _mdModal",
        modalTitle: "Eway Bill Manually",
        submitTitle: "Add Manually",
        footerPart: true,
        showPrefield: showPrefield,
    }

    const fetchEwayBillListData = async () => {
        setLoading(true);
        try {
            if (loadingBarRef.current) {
                loadingBarRef.current.continuousStart(); // Start the loading bar
            }
            let object = {
                ...filter,
                branch_id: getEwayBillFilters?.branch_id ? getEwayBillFilters?.branch_id : '',
                consignor_id: getEwayBillFilters?.consignor_id ? getEwayBillFilters?.consignor_id : '',
                from_location: getEwayBillFilters?.from_location ? getEwayBillFilters?.from_location : '',
                to_location: getEwayBillFilters?.to_location ? getEwayBillFilters?.to_location : '',
                lr_status: getEwayBillFilters?.lr_status ? getEwayBillFilters?.lr_status : 0,
                pod_status: getEwayBillFilters?.pod_status ? getEwayBillFilters?.pod_status : 0,
                eway_bill_status: getEwayBillFilters?.eway_bill_status > 0 ? getEwayBillFilters?.eway_bill_status : '',
                search: getEwayBillFilters?.search ? getEwayBillFilters?.search : '',
                start_date: getEwayBillFilters?.start_date ? moment(getEwayBillFilters?.start_date)?.format("YYYY-MM-DD") : '',
                end_date: getEwayBillFilters?.end_date ? moment(getEwayBillFilters?.end_date)?.format("YYYY-MM-DD") : '',
                // start_date: getEwayBillFilters?.start_date ? moment(getEwayBillFilters?.start_date) : '',
                // end_date: getEwayBillFilters?.end_date ? moment(getEwayBillFilters?.end_date) : '',
                company_id: StorageService.getCompanyId(),
                firm_id: StorageService.getFirmId(),
            }
            if (getEwayBillFilters?.eway_bill_status === 0) {
                delete object.eway_bill_status;
            }
            const res = await getEwayBillList(object);
            if (res?.responseCode == 200) {
                setEwayBillList(res?.data?.lr_list);
                let counts = res?.data?.lrCount_header;
                let newArray = [
                    { id: 0, value: "active_lr", count: counts?.allActiveLR, title: "Active LR" },
                    { id: 1, value: "no_eway", count: counts?.noEwayLR, title: "Without Eway" },
                    { id: 2, value: "active_eway", count: counts?.activeEwayLR, title: "Active Eway" },
                    // { id: 3,value: "closed", count: 0, title: "Closed" },
                    { id: 4, value: "expiring_today", count: counts?.expiringTodayLR, title: "Expiring Today" },
                    { id: 5, value: "expired", count: counts?.expiredLR, title: "Expired" },
                    { id: 6, value: "auto_extention_failed", count: 0, title: "Auto Extention Failed" }
                ]
                // let newArray = [
                //     { id: 1, title: "Active LR", value: "active_lr", count: counts?.allActiveLR },
                //     { id: 2, title: "Active Eway", value: "active_eway", count: counts?.activeEwayLR },
                //     { id: 3, title: "No Eway", value: "no_eway", count: counts?.noEwayLR },
                //     { id: 4, title: "Expiring Today", value: "expiring_today", count: counts?.expiringTodayLR },
                //     { id: 5, title: "Expired", value: "expired", count: counts?.expiredLR },
                //     { id: 6, title: "Auto Extention Failed", value: "auto_extention_failed", count: 0 },
                // ]
                setHeaderCounts(newArray);
                setTotalItems(res?.data?.total_count);
                setLoading(false);
            } else {
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
        } finally {
            if (loadingBarRef.current) {
                loadingBarRef.current.complete(); // Complete the loading bar
            }
        }
    }

    let permissionModalProps = {
        isOpen: permissionModal,
        closeModal: (e) => setPermissionModal(!permissionModal),
        modalMainClass: "_dashCommon_Modal _smModal",
        modalTitle: "Permission",
        submitTitle: "Close",
        message: `You don't have access to create a trip`,
        firstSubmitTitle: 'Close',
        firstSubmitHandler: (e) => setPermissionModal(!permissionModal),
        hideSecondButton: false
    }

    useEffect(() => {
        setFilter((s) => ({
            ...s,
            ...getEwayBillFilters
        }))
        fetchEwayBillListData();
    }, [getEwayBillFilters])

    const handlePageChange = (page) => {
        setFilter((s) => ({ ...s, offset: page }))
        let tabFilter = { ...getEwayBillFilters, offset: page };
        dispatch(updateEwayBillFilters(tabFilter))
    };

    const fetchData = async () => {
        try {
            const [consignorRes, branchRes] =
                await Promise.all([
                    getConsignorList(),
                    getBranchList()
                ]);

            const consignorList = formatList(
                consignorRes?.data?.consignor_list,
                "name",
                "_id",
                "All"
            );
            const branchList = formatList(
                branchRes?.data?.branch_list,
                "branch",
                "_id",
                "All"
            );

            setListData({
                consignorList,
                branchList,
            });

            // setLoading(false);
        } catch (error) {
            // setLoading(false);
        }
    };

    const getConsignorList = async () => {
        let object = { company_id: StorageService.getCompanyId(), firm_id: StorageService.getFirmId() };
        return commonFetchFuction(getConsignorDropdownListData, object);
    };

    const getBranchList = async () => {
        let object = { company_id: StorageService.getCompanyId(), firm_id: StorageService.getFirmId() };
        return commonFetchFuction(getBranchDropdownListData, object);
    };

    const formatList = (list, labelKey, valueKey, defaultOption = null) => {
        const formattedList = list?.map((item) => ({
            ...item,
            label: item[labelKey],
            value: item[valueKey],
        }));
        return defaultOption
            ? [{ label: defaultOption, value: "" }, ...formattedList]
            : formattedList;
    };

    const commonFetchFuction = async (
        apiMethod,
        payload = {},
        transformer = (res) => res
    ) => {
        try {
            const res = await apiMethod(payload);
            if (res?.responseCode === 200) {
                return transformer(res);
            } else {
                toast.error(res?.responseMessage);
            }
        } catch (error) {
            toast.error(error?.message || "Something went wrong");
        }
    };

    useEffect(() => {
        if (showFilterModal) {
            fetchData();
        }
    }, [showFilterModal])

    useEffect(() => {
        setActiveTab(getEwayBillFilters?.eway_bill_status);
    }, [getEwayBillFilters?.eway_bill_status])

    const clearFilter = () => {
        setFilter((pre) => ({
            ...pre,
            search: "",
            branch_id: "",
            consignor_id: "",
            start_date: "",
            end_date: "",
            from_location: "",
            to_location: "",
            lr_status: 0,
            pod_status: 0,
            eway_bill_status: 0,
            offset: 1
        }));
        dispatch(updateEwayBillFilters({
            search: "",
            branch_id: "",
            consignor_id: "",
            start_date: "",
            end_date: "",
            from_location: "",
            to_location: "",
            lr_status: 0,
            pod_status: 0,
            eway_bill_status: 0,
            offset: 1
        }))
        setFilterCount(0);
    };

    useEffect(() => {
        const prevTripFilter = prevTripFilterRef.current;

        if (JSON.stringify(prevTripFilter) !== JSON.stringify(filter)) {
            const filteredValues = Object.entries(filter)
                .filter(
                    ([key, val]) =>
                        key !== "offset" &&
                        key !== "limit" &&
                        key !== "company_id" &&
                        key !== "eway_bill_status" &&
                        val !== "" &&
                        val !== null &&
                        val !== undefined &&
                        val !== 0
                )
                .map(([_, val]) => val);

            setFilterCount(filteredValues.length);
            prevTripFilterRef.current = filter;
        }
    }, [filter]);

    const handleDetailsAction = (data) => {
        setShowEwayBillDetail(data);
    }

    const handleNextModal = (data) => {
        setShowEwayBillDetail(!showEwayBillDetail);
        setShowEwayBillModel({ ...data, isEwayBillLrEdit: true });
    }

    const extendEwayHandler = (event, item) => {
        event.preventDefault();
        handlePermissionCall(event, item)
    }

    const showTimeValidityExtendModel = (event) => {
        event.preventDefault();
        setPermissionModal(true);
    }

    const lrInformation = async (payloadObj) => {
        try {
            const res = await updateLrInformation(payloadObj);
            if (res?.responseCode === 200) {
                fetchEwayBillListData();
                setCurrentItemData({});
                toast.success(res?.responseMessage);
            } else {
                if (res?.responseMessage) {
                    toast.error(res?.responseMessage);
                }
            }
        } catch (error) {
            toast.error(error?.message || "Something went wrong");
        }
    }

    const callBackDataMaps = async (data) => {
        let obj = {
            type: "Manually",
            location: `${data?.name} ${data?.stateName} , ${data?.postalCode} ${data?.countryName}`,
            datetime: new Date(),
        }
        let payload = {
            lr_id: currentItemData?._id,
            company_id: currentItemData?.company_id,
            eway_location: obj,
        }
        lrInformation(payload)
    }

    let gmapLocates = {
        isOpen: openLoction,
        closeModal: (e) => setOpenLoction((s) => ({ ...s, open: false, action: '' })),
        modalMainClass: "_dashCommon_Modal _mdModalLoction",
        modalTitle: openLoction?.action === 'edit' ? 'Update Location' : 'Add Location',
        submitTitle: openLoction?.action === 'edit' ? 'Update Location' : 'Add Location',
        callBackDataMap: callBackDataMaps,
        isEwayBillMap: true,
        showPinCode: true,
    };

    const handlePermissionCall = async (e, item) => {
        e.preventDefault();

        await actionPermission({
            company_id: StorageService.getCompanyId(),
            type: constant?.USABILITY_CONFIG_TYPES?.EWAY_EXTEND,
            onSuccess: () => setShowExtendEway(item),
            setModalConfig, // Pass setter
        });
    };

    const handlePermissionCallTrip = async (link) => {
        await actionPermission({
            company_id: StorageService.getCompanyId(),
            type: constant?.USABILITY_CONFIG_TYPES?.TRIP,
            onSuccess: () => navigate(link),
            setModalConfig
        });
    };

    let ebillExpProps = {
        isOpen: modalConfig.isOpen,
        closeModal: () => setModalConfig(prev => ({ ...prev, isOpen: false })),
        onSubmit: (e) => setModalConfig(prev => ({ ...prev, isOpen: false })),
        modalMainClass: " _dashCommon_Modal __actionPermissionModal _smModal",
        headerPart: true,
        floatCrossBtn: true,
        submitTitle: "Send Enquiry",
        messageType: modalConfig.messageType,
        templateId: modalConfig.templateId,
        templateData: modalConfig.templateData
    };

    const youtubeProps = {
        isOpen: youtubeVideos,
        closeModal: () => setYoutubeVideos((s) => ({ ...s, moduleName: '', moduleAction: false })),
        headerPart: false,
        modalTitle: `Add Eway Bill`,
        submitTitle: `Add Eway Bill`,
        modalMainClass: "_mdModal",
        videosModuleName: constant.Key.eway_bill
    }

    return (
        <>
            <LoadingBar
                color="#ffa800"
                ref={loadingBarRef}
                height={4}
                shadow={true}
                loaderSpeed={1000}
            />

            <ButtonHeading
                title="EwayBill"
                onClick={(e) => setShow(!show)}
                buttonTitle="Add Eway Bill"
                showSearchFilter={{ search: true, filterOption: true, filterCount: true }}
                onClickFilterModal={(e) => setShowFilterModal(!showFilterModal)}
                filter={filter}
                setFilter={setFilter}
                isDebouncedSearch={false}
                filterCount={filterCount}
                clearFilter={clearFilter}
                isEwaySearchApply={true}
                showYouTubeIcon={true}
                youTubeOnClick={(e) => setYoutubeVideos((s) => ({ ...s, moduleName: 'eway_creation', moduleAction: true }))}
            />

            <div className='__eWay_main'>
                <div className='addPr_flBx'>
                    <Tab {...tabProps} />

                    < div className="_indTabl_right">
                        <div className="_indentTable _planLTable">
                            <table className="__tPlain_table" style={{height: loading ? "100%" : "auto"}}>
                                <thead>
                                    <tr>
                                        <th>LR No.</th>
                                        <th>Trip Number</th>
                                        <th>Party</th>
                                        <th>From Station</th>
                                        <th>To Station</th>
                                        <th>Eway Bill</th>
                                        <th>Expiry Date</th>
                                        <th>Vehicle</th>
                                        <th>LR Status</th>
                                    </tr>
                                </thead>
                                {loading ?
                                    <tbody>
                                        <tr>
                                            <td style={{ borderBottom: '1px solid var(--light-gray)', padding: '6px 18px' }} colSpan={9}>
                                                <div className='h-100 bg-white d-flex align-items-center justify-content-center rounded-2'>
                                                    <Loading />
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody> :
                                    (ewayBillList?.length > 0 ?
                                        ewayBillList?.map((item, index) => {
                                            return (
                                                <React.Fragment key={index}>

                                                    <tbody>
                                                        <tr className="eway-frst-tr">
                                                            <td>
                                                                {item?.lr_number ?
                                                                    <div className='_tblText _lrNums' onClick={(e) => handleDetailsAction(item)}>
                                                                        <a className='_avPointer'> {item?.lr_number} </a>
                                                                    </div>
                                                                    :
                                                                    <div className='_tblText _lrNums' onClick={(e) => handleDetailsAction(item)}>
                                                                        <a className='_avPointer'> View </a>
                                                                    </div>
                                                                }
                                                            </td>

                                                            <td>
                                                                {item?.trip_id?.trip_number ?
                                                                    <div className='_tblText _lrNums' onClick={(e) => navigate(`/trip/addtrip/dispatched/${item?.trip_id?._id}`)}>
                                                                        <a className='_avPointer'>
                                                                            {item?.trip_id?.trip_number}
                                                                        </a>
                                                                    </div>
                                                                    :
                                                                    childsUser?.create === 1 ? <button className='__add_tbData_btn' onClick={() => { setLrDetialsFrom(item); handlePermissionCallTrip('/trip/addtrip/createtrip2'); }}>
                                                                        + Create Trip
                                                                    </button> : <button className='__add_tbData_btn' onClick={() => setPermissionModal(true)}>
                                                                        + Create Trip
                                                                    </button>
                                                                }
                                                            </td>
                                                            <td><p className="_tblText_inDent curser_pointer">{item?.consignor_id?.name ? item?.consignor_id?.name : '-'}</p></td>
                                                            <td>
                                                                <p className="_tblText">{item?.from_location ? item?.from_location : '-'}</p>
                                                                <CustomTooltip txtClass="__tooltipTxt_bx">
                                                                    <p className="_lgtText">{item?.unit_id?.code ? item?.unit_id?.code : ''} {item?.unit_id?.code && item?.unit_id?.name ? '|' : ''} {item?.unit_id?.name ? item?.unit_id?.name : ''}</p>
                                                                </CustomTooltip>
                                                            </td>
                                                            <td>
                                                                <p className="_tblText">{item?.to_location ? item?.to_location : '-'}</p>
                                                                <CustomTooltip txtClass="__tooltipTxt_bx">
                                                                    <p className="_lgtText">{item?.consignee_id?.code ? item?.consignee_id?.code : ''} {item?.consignee_id?.code && item?.consignee_id?.name ? '|' : ''} {item?.consignee_id?.name ? item?.consignee_id?.name : ''}</p>
                                                                </CustomTooltip>
                                                            </td>
                                                            <td>
                                                                {item?.eway_bill_number ?
                                                                    <div className="_dateNtime">
                                                                        <div className="__locationWid_bx">
                                                                            <p className="_tblText_inDent">
                                                                                {item?.eway_bill_number ? item?.eway_bill_number : '-'}
                                                                            </p>
                                                                        </div>

                                                                        <p className="_lgtText_inDent">
                                                                            {item?.eway_bill_date ? moment(item?.eway_bill_date).format('DD MMM YYYY') : ''} {item?.eway_bill_date ? '|' : ''} {item?.eway_bill_date ? moment(item?.eway_bill_date).format('hh:mm A') : ''}
                                                                        </p>
                                                                    </div> :
                                                                    <button className='__add_tbData_btn' onClick={() => setShow(item)}> + Add Eway Bill </button>
                                                                }
                                                            </td>

                                                            <td>
                                                                <div className="_dateNtime">
                                                                    <div className="__locationWid_bx">
                                                                        <p className="_tblText_inDent">
                                                                            {item?.eway_expiry_date ? customizeDate(item?.eway_expiry_date) : '-'}
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </td>

                                                            <td>
                                                                <p className="_tblText">{item?.trip_id?.vehicle_id?.vehicle_no ? item?.trip_id?.vehicle_id?.vehicle_no : '-'}</p>
                                                                <CustomTooltip txtClass="__tooltipTxt_bx">
                                                                    <p className="_lgtText">{item?.trip_id?.driver_id?.name ? item?.trip_id?.driver_id?.name : item?.trip_id?.supplier_id?.name}</p>
                                                                </CustomTooltip>
                                                            </td>

                                                            <td><span className={masterData?.lr_status[item?.lr_status] === 'Pending' ? '_lrPending_status' : (masterData?.lr_status[item?.lr_status] === 'In Transit' ? '_lrInTransit_status' : (masterData?.lr_status[item?.lr_status] === 'At Party Point' ? '_lrPartyPoint_status' : ((masterData?.lr_status[item?.lr_status] === 'Delivered' ? '_lrDelivered_status' : (masterData?.lr_status[item?.lr_status] === 'Bill Raised' ? '_lrBillRaised_status' : '')))))}> {masterData?.lr_status[item?.lr_status] ? masterData?.lr_status[item?.lr_status] : ''} </span></td>
                                                        </tr>

                                                        <tr>
                                                            <td style={{ borderBottom: '1px solid var(--light-gray)', padding: '6px 10px' }} colSpan={9}>
                                                                <div className='__eWy_detailFx'>
                                                                    <div className='__eWy_extOtr'>
                                                                        {item?.eway_bill_number ?
                                                                            <>
                                                                                {utils.shouldShowButton(item?.eway_expiry_date) ?
                                                                                    <>
                                                                                        {isButtonEnabled ? <button className='anime-btn __extendEw_btn' onClick={(e) => extendEwayHandler(e, item)} disabled={!isButtonEnabled}>
                                                                                            Extend Eway
                                                                                        </button>
                                                                                            :
                                                                                            <button className='anime-btn __extendEw_btn' onClick={(e) => extendEwayHandler(e, item)}>
                                                                                                Extend Eway
                                                                                            </button>
                                                                                            // <button className='anime-btn __extendEw_btn' onClick={(e) => showTimeValidityExtendModel(e)}>
                                                                                            //     Extend Eway
                                                                                            // </button>
                                                                                        }
                                                                                    </> :
                                                                                    <button className='anime-btn __extendEw_btn' onClick={(e) => setShowExtendEway({ ...item, extend_details: true })}>
                                                                                        Extend Details
                                                                                    </button>
                                                                                }
                                                                            </> :
                                                                            <button className='anime-btn __extendEw_btn' onClick={() => { setShow(item); setDisableBranchConsignor(true) }}>
                                                                                Add Eway Bill
                                                                            </button>
                                                                        }

                                                                        <div className={item?.eway_timeline?.length > 0 ? '__timeline_outer' : '__timeline_pd_right_rm'} onClick={() => item?.eway_timeline?.length > 0 ? setShowEwayTimeline(item?.eway_timeline) : {}}>
                                                                            <div className="__timeline-badge">
                                                                                <span className="__tb-label">Time Line</span>
                                                                                <span className="__tb-circle"> {item?.eway_timeline?.length > 0 ? item?.eway_timeline?.length : 0}</span>
                                                                            </div>
                                                                            {item?.eway_timeline?.length > 0 ? <span className="__tb-text"> {item?.eway_timeline.at(-1)?.title ? item?.eway_timeline.at(-1)?.title : '-'} {item?.eway_timeline?.at(-1)?.date_time ? getTodayDate(item?.eway_timeline?.at(-1)?.date_time) : ''}</span> : <></>}
                                                                        </div>

                                                                        {/* FOR ARJUN */}
                                                                        {/* <button onClick={() => setShowEwayDetail(true)}>eway bill detail</button> */}
                                                                        {/* FOR ARJUN */}
                                                                    </div>

                                                                    <div className='__extensionBx-otr'>
                                                                        <span className={item?.is_eway_fetch ? "_lrDelivered_status" : "_lrPending_status"}> Extension - {item?.is_eway_fetch ? 'Auto' : 'Manually'}</span>

                                                                        {item?.eway_location?.location ? (
                                                                            <div className='__locateAdd_main' onClick={(e) => setShowExtendEway({ ...item, extend_details: true })}>
                                                                                <div className='__iconLocate'>
                                                                                    <IoLocationSharp />
                                                                                </div>
                                                                                <div className='__locatePlace'>
                                                                                    <p>{item?.eway_location?.location ? item?.eway_location?.location : '-'}</p>
                                                                                    <span>{item?.eway_location?.datetime ? moment(item?.eway_location?.datetime).format('DD MMM YYYY') : ''} {item?.eway_location?.datetime ? '|' : ''} {item?.eway_location?.datetime ? moment(item?.eway_location?.datetime).format('hh:mm A') : ''}</span>
                                                                                </div>
                                                                            </div>) :
                                                                            <div className='__locateAdd_main' onClick={() => { setOpenLoction((s) => ({ ...s, open: true, action: 'add' })); setCurrentItemData(item) }}>
                                                                                <div className='__iconLocate'>
                                                                                    <IoLocationSharp />
                                                                                </div>
                                                                                <div className='__locatePlace'>
                                                                                    <p> + Add Location </p>
                                                                                    <span> </span>
                                                                                </div>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </td>
                                                        </tr>

                                                        <tr>
                                                            <td colSpan={9} style={{ padding: '2px', background: '#f7f9ff' }}></td>
                                                        </tr>
                                                    </tbody>
                                                </React.Fragment>
                                            )
                                        })
                                        :
                                        <tbody>
                                            <tr>
                                                <td style={{ borderBottom: '1px solid var(--light-gray)', padding: '6px 18px' }} colSpan={9}>
                                                    <div className='__eWy_detailFx'>
                                                        <div className='__eWy_extOtr'>
                                                            No data found
                                                        </div>
                                                        <div className='__extensionBx-otr'></div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    )}
                            </table>
                        </div>
                    </div>

                    {ewayBillList?.length > 0 ? <div className='paginationFt_avt'>
                        <CustomPagination
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            currentPage={filter?.offset}
                            onPageChange={handlePageChange}
                        />
                    </div> : <></>}
                </div>
            </div >

            {show
                && (
                    <AddEwayBillModal {...firstAddEwayBillModal} />
                )
            }

            {showEwayParty
                && (
                    <AddEwayPartyModal {...secondAddEwayBillModal} />
                )
            }

            <div
                className={`offcanvas offcanvas-end common_offCanvas slidedOffCanvas ${showEwayDetail ? "open" : ""} ${isClosing ? "closing" : ""}`}
                tabIndex={-1}
                style={{ visibility: showEwayDetail || isClosing ? "visible" : "hidden" }}
            >
                {showEwayDetail &&
                    <EwayBillNewDetailsModal
                        isOpen={showEwayDetail} // { ...showEwayDetail, ...consignorPermission }
                        onClose={() => setShowEwayDetail(false)}
                        fetchNextModal={(e) => setShowEwayBillModel(e)}
                    // previousModel={() => }
                    />}
            </div>

            <div className={showEwayDetail || isClosing ? "offBack_drop " : ""}></div>

            <div
                className={`offcanvas offcanvas-end common_offCanvas addLr_xxl_Offcanvas ${showEwayBillModel ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: showEwayBillModel ? 'visible' : 'hidden' }}
            >
                {showEwayBillModel
                    && (
                        <AddEditEwayBillLrModal
                            isOpen={showEwayBillModel} // { ...showEwayBillModel, ...consignorPermission }
                            onClose={() => setShowEwayBillModel(false)}
                            callGetData={() => fetchEwayBillListData()}
                        />
                    )
                }
            </div>
            <div className={showEwayBillModel ? 'offBack_drop' : ''}></div>

            <div
                className={`offcanvas offcanvas-end common_offCanvas ${isAddConsignor ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: isAddConsignor ? 'visible' : 'hidden' }}
            >
                {isAddConsignor &&
                    <AddEditConsignor
                        isOpen={isAddConsignor}
                        onClose={() => setIsAddConsignor(false)}
                        isPreviousModal={(e) => setShow(e)}
                        showingPrefield={(e) => setShowingPrefield(true)}
                        isEwayBillTrue={true}
                        withoutFirstModalDirectLrOpen={(e) => setShowEwayBillModel(e)}
                        hideAddNewOption={false}
                        branchFirmId={ewayBillInitialData?.branch_id?.firm_id?._id ? ewayBillInitialData?.branch_id?.firm_id?._id : StorageService?.getFirmId()}
                    />
                }
            </div>
            <div className={isAddConsignor ? 'offBack_drop' : ''}></div>

            {
                permissionModal
                && (
                    <PermissionModal {...permissionModalProps} />
                )
            }

            <div
                className={`offcanvas offcanvas-end common_offCanvas mdOffcanvas ${showExtendEway ? "show" : ""}`}
                tabIndex={-1}
                style={{ visibility: showExtendEway ? "visible" : "hidden" }}
            >
                {showExtendEway && <ExtendEwayBillModal
                    isOpen={showExtendEway}
                    onClose={(e) => setShowExtendEway(false)}
                    callGetData={() => fetchEwayBillListData()}
                />}
            </div>
            <div className={showExtendEway ? "offBack_drop" : ""}></div>

            <div
                className={`offcanvas offcanvas-end common_offCanvas mdOffcanvas ${showEwayTimeline ? "show" : ""}`}
                tabIndex={-1}
                style={{ visibility: showEwayTimeline ? "visible" : "hidden" }}
            >
                {showEwayTimeline && <TimeLineEwayModal
                    isOpen={showEwayTimeline}
                    onClose={() => setShowEwayTimeline(false)}
                />}
            </div>
            <div className={showEwayTimeline ? "offBack_drop" : ""}></div>

            <div
                className={`offcanvas offcanvas-end common_offCanvas ${showFilterModal ? "show" : ""
                    }`}
                tabIndex={-1}
                style={{ visibility: showFilterModal ? "visible" : "hidden" }}
            >
                {showFilterModal && (
                    <EwayBillFilterModal
                        isOpen={showFilterModal}
                        onClose={(e) => setShowFilterModal(false)}
                        filter={filter}
                        setFilter={setFilter}
                        isShow={{
                            dateRange: true,
                            allBranch: true,
                            consignor: true,
                            fromLocation: true,
                            toLocation: true,
                            isLr_status: true,
                            isPod_status: true,
                            isEway_bill_status: false,
                            supplier: false,
                            driver: false,
                            search: false,
                            ownership: false,
                            tripStatus: false,
                            vehicle: false
                        }}
                        list={{
                            branch: listData?.branchList,
                            consignor: listData?.consignorList,
                        }}
                        setFilterCount={setFilterCount}
                        name="ewayBill"
                    />
                )}
            </div>
            <div className={showFilterModal ? "offBack_drop" : ""}></div>

            <div
                className={`offcanvas offcanvas-end common_offCanvas xxlOffcanvas ${showEwayBillDetail ? 'show' : ''}`}
                tabIndex={-1}
                style={{ visibility: showEwayBillDetail ? 'visible' : 'hidden' }}
            >
                {showEwayBillDetail
                    && (
                        <LrDetailModal
                            isOpen={showEwayBillDetail}
                            onClose={(e) => setShowEwayBillDetail(false)}
                            nextModal={(e) => handleNextModal(e)}
                            ewayBillStatusDetails={true}
                        />
                    )
                }
            </div>
            <div className={showEwayBillDetail ? 'offBack_drop' : ''}></div>

            {openLoction?.open && <AddLocationModal {...gmapLocates} />}
            {modalConfig.isOpen && <EbillExtentionModal

                {...ebillExpProps}

            />}

            {
                (youtubeVideos?.moduleName === 'eway_creation' && youtubeVideos?.moduleAction === true)
                && (
                    <YoutubeModal {...youtubeProps} />
                )
            }
        </>
    )
}

export default React.memo(EwayBill);
